import { render, staticRenderFns } from "./AddUpdateCatalogGroup.vue?vue&type=template&id=66dc9f5c&"
import script from "./AddUpdateCatalogGroup.vue?vue&type=script&lang=js&"
export * from "./AddUpdateCatalogGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports